export class ApplicationDate extends Date {
  /**
   * Format the date to a natural format
   * @returns The formatted date
   */
  public toNaturalDate(): string {
    const today = new Date();
    const dayNames = [
      'Dimanche',
      'Lundi',
      'Mardi',
      'Mercredi',
      'Jeudi',
      'Vendredi',
      'Samedi',
    ];
    const monthNames = [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ];

    const timeString = this.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
    });

    // Same day
    if (this.toDateString() === today.toDateString()) {
      return timeString;
    }

    // Yesterday
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    if (this.toDateString() === yesterday.toDateString()) {
      return `Hier ${timeString}`;
    }

    // Same week
    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(today.getDate() - 7);
    if (this > oneWeekAgo) {
      return `${dayNames[this.getDay()]} ${timeString}`;
    }

    // Same year
    if (this.getFullYear() === today.getFullYear()) {
      return `${dayNames[this.getDay()]} ${this.getDate()} ${monthNames[this.getMonth()]} à ${timeString}`;
    }

    // Different year
    return `${this.getDate()} ${monthNames[this.getMonth()]} ${this.getFullYear()} à ${timeString}`;
  }
}
